import React from "react";
import api from "../../../utility/api/api.js";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import {
  Route,
  BrowserRouter,
  NavLink,
  Switch,
  withRouter,
} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import {
  actionOrderDetails,
  actionGetReturnReasons,
} from "../../../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import loader from "../../../images/loader.gif";
class ReturnReason extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, getReturnState: "", isLoading: false };
    // this.masterData = JSON.parse(localStorage.getItem("getMasterData"));
    this.toggle = this.toggle.bind(this);
    const history = createHistory();
    const unlisten = history.listen((location, action) => {
      if (this.state.modal) {
        this.setState({ modal: false });
      }
    });
  }
  componentDidMount() {
    // this.timerId = setInterval(() => this.getLocation(), 1000);
    api.getReturnReasons(this);
  }
  async toggle(data, e) {
    if (data === "ReturnOk") {
      if (document.querySelector("input[name='return_reason']:checked")) {
        let value = document.querySelector(
          "input[name='return_reason']:checked"
        ).value;

        //  api.delayTrip(this.props.trip_id,value,time,'delaytrip',this);
        // console.log("toggle", this.props.orderData, value);
        // alert(value);
        // let tripdata = Object.assign({}, this.props.orderData);
        // let items = this.props.orderData.orderData.items;
        // let qty_refused = false;
        // for (let obj in items) {
        //   if (items[obj].qty_refused) {
        //     qty_refused = true;
        //     break;
        //   }
        // }
        // if (!qty_refused) {
        //   this.setState({ error: "Products not refushed yet" });
        //   e.preventDefault();
        //   return;
        // }
        // tripdata.orderData.return_reason = value;
        // this.props.actionOrderDetails(tripdata);
        this.setState({ isLoading: true });
        await api.returnReasonPost(this.props.orderData.job_order_id, value);
        this.setState({ isLoading: false });
        this.props.history.push("/intransit");
      } else {
        this.setState({ error: "Please Select the field" });
        e.preventDefault();
        return;
      }
    }
    this.setState({
      modal: !this.state.modal,
      error: "",
    });
  }

  render() {
    if (this.props.returnReasons) {
      const return_reason = this.props.returnReasons;
      return (
        <BrowserRouter>
          <div>
            <NavLink
              onClick={this.toggle}
              className="orderAnchor"
              to="/intransit/returnproducts"
            >
              {/* <button
                className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancel orange-btn"
                onClick={this.toggle}
              >
                Return
              </button> */}
              CANCEL
            </NavLink>
            <Switch>
              <Route path="/intransit/returnproducts">
                <Modal
                  isOpen={this.state.modal}
                  backdrop={"static"}
                  keyboard={false}
                  fade={false}
                  toggle={this.toggle}
                  className={this.props.className}
                >
                  <ModalHeader className="justify-content-center py-2 alert-secondary">
                    Reason to Return ?
                  </ModalHeader>
                  <ModalBody>
                    <div className="select-reason-title">SELECT REASON</div>
                    {return_reason.map((obj, key) => (
                      <div key={key}>
                        <div>
                          <input
                            className="with-gap custom-check"
                            onChange={(e) => this.setState({ error: "" })}
                            value={obj.reason}
                            id={`return_${key}`}
                            name="return_reason"
                            type="radio"
                          />
                          <Label htmlFor={`return_${key}`}>{obj.reason}</Label>
                        </div>
                      </div>
                    ))}
                    <div className="text-danger">{this.state.error}</div>
                  </ModalBody>
                  <ModalFooter className="p-0 border-0">
                    <span className="col-6 text-center">
                      <NavLink to="/deliveryorder">
                        <button
                          className="btn bg-white m-0 py-2"
                          onClick={this.toggle}
                        >
                          Cancel
                        </button>
                      </NavLink>
                    </span>
                    <span className="col-6 text-center">
                      {this.state.isLoading ? (
                        <img src={loader} height="40px" />
                      ) : (
                        <div
                          className=" m-0 py-2 modalbutton"
                          exact
                          to="/intransit"
                          onClick={(e) => this.toggle("ReturnOk", e)}
                        >
                          OK, Done
                        </div>
                      )}
                    </span>{" "}
                  </ModalFooter>
                </Modal>
              </Route>
            </Switch>
          </div>
        </BrowserRouter>
      );
    } else {
      return null;
      // (
      //   <div>
      //     <Button onClick={this.toggle}>{this.props.label}</Button>
      //   </div>
      // );
    }
  }
}

function mapStateToProps(state) {
  console.log("GunaReasons", state);
  return {
    returnReasons: state.returnReasons,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionOrderDetails: actionOrderDetails,
      actionGetReturnReasons: actionGetReturnReasons,
    },
    dispatch
  );
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReturnReason)
);



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/ReturnReason.js